export default __webpack_public_path__ + "media/music/3668fba0576e3db1250af81de3193088.mp3";